import { authHeader, localStorageUserKey } from '@mobile/services/user';
import axios from '@mobile/util/axios';
import config from 'config';
import globals from '@/util/globals';

export default {
    namespaced: true,

    state: {
        requesting: false,
    },

    actions: {
        async submit({ commit }, { toast, ...payload }) {
            try {
                const {
                    data,
                } = await axios.post(
                    `${config.apiUrl}/${config.apiVersion}/authenticate/me`,
                    payload,
                    { headers: authHeader() },
                );

                localStorage.setItem(localStorageUserKey, JSON.stringify(data));
                commit('authentication/setUser', data, { root: true });

                toast('Your profile has been updated.');
                globals.location.reload(); // reload page to refresh translations from backend
            } catch (error) {
                // only show error if it was a server error
                if (error.response && error.response.status) {
                    toast('Error saving profile!', 'error');
                }
            }
        },
    },

    mutations: {},

    getters: {
        user: (state) => state.user,
    },
};
